import PrivacyPolicy from "../components/privacy/Privacy"
import FAQItem from "../components/questions/Questions"
import styles from "./ForthScreen.module.css"

const ForthScreen = () => {
  return (
    <>
      <div className={styles.title}>
        אתם שואלים <span className={styles.highlight}>ואני עונה</span>
      </div>

      <div className={styles.description}>לחצו על כל שאלה כדי שהתשובה תיפתח</div>

      <FAQItem
        question="מה אם אני לא יודע מאיפה להתחיל אפילו?"
        answer="זה בסדר מוחלט. אתה לא צריך להגיע עם כיוון. אני עוזרת לך לבנות אותו.  אנחנו מתחילים מהאסטרטגיה ובונים אותה יחד עד למצב שאתה מצטלם בנוח לתוכן שממגנט אליך לקוחות אנחנו מתקדמים צעד אחר צעד לעבר המטרה"
      />

      <FAQItem
        question="ניסיתי ליווי שיווקי בעבר וזה לא הביא תוצאות למה שזה יעבוד הפעם"
        answer="מבאס אותי לשמוע שנכוות בעבר ואני אשמח לשמוע ממך בדיוק למה ציפית ומה קיבלת, אבל אצלנו זה אחרת! אתה מקבל ליווי מלא ומקיף מקצה לקצה משלב כתיבת התוכן עד לצילום שלו וכמוב לניהול התוכן ברשתות - והתוצאות מדברות!"
      />



      <FAQItem
        question="אני לא טוב מול מצלמה או בכתיבה"
        answer="אף אחד לא נולד עם הכשרון הזה אתה יכול להיות רגוע :)  אני איתך בזה - מרגיעה כשצריף ומכוונת כשאתה מאבד את הפוקוס לרגע - מהנסיון שלי, אחרי כמה רגעים הכל מתחיל לזרום."
      />

      <FAQItem
        question="אני לא מרגיש נוח מול מצלמה, איך הליווי יעזור לי?"
        answer="אני מבינה את החשש ואני יכולה לומר לך בפה מלא שאתה לא היחיד שמרגיש ככה.. המצלמה נדלקת ומשהו בך מרגיש לא טבעי.. חשוב לי שתדע ,אני איתך בזה! אני כאן להצחיק ולהרגיע ולגרום לך להרגיש שהמצלמה לא קייימת בכלל, הביטחון נבנה  בהדרגה.. ואל תדאג - אני לא מגבילה בטייקים :)"
      />
      <PrivacyPolicy/>
    </>
  )
}

export default ForthScreen
